import controller from './mail-form-header.controller';
import template from './mail-form-header.html';
import './mail-form-header.scss';

export default {
	template,
	bindings: {
		data:     '<ngModel',
		options:  '<?',
		required: '<?ngRequired',
		disabled: '<?ngDisabled',
	},
	controller,
	require:  {
		ngModelCtrl: '?ngModel',
	},
};
